import { render, staticRenderFns } from "./WidgetEdit.vue?vue&type=template&id=f16f25ba&"
import script from "./WidgetEdit.vue?vue&type=script&lang=ts&"
export * from "./WidgetEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports